import React, { FC } from 'react'
import { format } from '@dt/fe-utils'
import './index.scss'

interface IProps {
  info: any;
  couponMap: any;
  onClick: () => void;
}

const Loading: FC<IProps> = (props: IProps) => {
  const { info, couponMap, onClick } = props
  return (
    <div
      className='prize-item'
      onClick={(e: any) => {
        e.stopPropagation()
        onClick && onClick()
      }}
    >
      <div className='title'>{info.sendValue || info.name}</div>
      <div className='coupon-area'>
        <div className='coupon-list'>
          {
            info.coupons.slice(0, info.coupons.length > 5 ? 5 : info.coupons.length).map((item: any) => {
              const couponInfo: any = couponMap[item.couponId]
              return couponInfo ? (
                <div
                  key={item.couponId}
                  className='coupon-item'
                  style={couponInfo.picture ? {
                    backgroundImage: `Url(${couponInfo.picture})`
                  } : {
                    backgroundColor: '#f4f4f4'
                  }}
                >
                  {!couponInfo.picture && <i className='iconfont icon-youhuiquan'></i>}
                </div>) : ''
            })
          }
          {
            info.coupons.length > 5 &&
              <div
                className='coupon-item'
                style={{
                  backgroundColor: '#f4f4f4'
                }}
              >
                <i className='iconfont icon-ellipsis'></i>
              </div>
          }
        </div>
        {/* <i className='iconfont icon-chevron-right'></i> */}
      </div>
      {info.addTime && <div className='times'>{format.toDateTime(info.addTime)}</div>}
    </div>
  )
}

export default Loading
